import React, { createContext, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';

export const AppContext = createContext();

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    cursor: 'default',
  },
  alertBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    opacity: '0.9 !important',
    '&:hover': {
      opacity: '1 !important',
    },
  },
  messageWrapper: {
    padding: '1em 1.5em 1em 1.5em',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    cursor: 'pointer',
    opacity: 0.5,
    marginRight: '1em',
    fill: 'white',
    '&:hover': {
      opacity: '1 !important',
    },
    transition: '.5s',
  },
}));

const CloseSVGIcon = () => {
  const classes = useStyles();
  return (
    <svg className={classes.closeIcon} xmlns="http://www.w3.org/2000/svg" height="20px" width="20px" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  );
};

const CustomizedSnackbars = ({ open, setOpen, severity, message }) => {
  const classes = useStyles();
  const colours = {
    success: '#4caf50',
    info: '#2196f3',
    warning: '#ff9800',
    error: '#f44336',
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <Snackbar key={message} open={open} autoHideDuration={5000} onClose={handleClose} onClick={handleClose}>
        <Paper className={classes.alertBox} style={{ backgroundColor: colours[severity] }} elevation={6}>
          <div className={classes.messageWrapper}>
            <div>{Array.isArray(message) ? message.map((msg, i) => <div key={i}>{msg}</div>) : message}</div>
          </div>
          <CloseSVGIcon />
        </Paper>
      </Snackbar>
    </div>
  );
};

const AppContextProvider = props => {
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('success');
  const [message, setMessage] = useState('');

  const showSuccess = message => showSnackBar(message, 'success');
  const showError = (message, error) => showSnackBar(message, 'error', error);
  const showInfo = message => showSnackBar(message, 'info');
  const showWarning = message => showSnackBar(message, 'warning');

  const showSnackBar = (message, severity, error) => {
    setMessage(message);
    setSeverity(severity);
    setOpen(true);
    error && console.error(error);
  };

  return (
    <AppContext.Provider value={{ showSuccess, showError, showInfo, showWarning }}>
      <CustomizedSnackbars open={open} setOpen={setOpen} severity={severity} message={message} />
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
